import { apiRequestWithChecks } from "./api";

export const passwordRecovery = {
    forgot(username) {
        return apiRequestWithChecks("PUT", "/api/authentication/forgot", null, {
            username,
        });
    },

    verify(username, code) {
        return apiRequestWithChecks("PUT", "/api/authentication/verify", null, {
            username,
            code,
        });
    },

    resetPassword(resetId, password, isInstalled) {
        return apiRequestWithChecks(
            "PUT",
            "/api/authentication/reset-password",
            null,
            {
                resetId,
                password,
                isInstalled,
            }
        );
    },

    getResendStatus(username) {
        return apiRequestWithChecks(
            "GET",
            `/api/authentication/resend-status?username=${encodeURIComponent(username)}`,
            null,
            null
        );
    },

    getUsernameForResetId(resetId) {
        return apiRequestWithChecks(
            "GET",
            `/api/authentication/reset-username?resetId=${encodeURIComponent(resetId)}`,
            null,
            null,
            false // don't toast on failure — this is a best-effort lookup
        );
    },

    validateResetToken(resetId) {
        return apiRequestWithChecks(
            "GET",
            `/api/authentication/validate-reset-token?resetId=${encodeURIComponent(resetId)}`,
            null,
            null,
            false // don't toast on failure — this is a best-effort upfront check
        );
    },
};